import {AttributionStorage} from './storage';
import type {AttributionModel} from './types';
import {isBrowser, isValidClickId, normalizeStringList} from './utils';

export class AttributionManager {
  private clickId: string | null = null;
  private readonly queryParameters: string[];

  constructor(
    private readonly storage: AttributionStorage,
    private readonly model: AttributionModel,
    queryParameters?: string[],
  ) {
    this.queryParameters = normalizeStringList(queryParameters, ['bq_id']);
    if (!this.queryParameters.length) this.queryParameters.push('bq_id');
  }

  captureFromLocation(): string | null {
    if (!isBrowser()) return this.getClickId();
    const params = new URLSearchParams(window.location.search);
    for (const parameter of this.queryParameters) {
      const candidate = params.get(parameter);
      if (isValidClickId(candidate)) return this.capture(candidate);
    }
    return this.getClickId();
  }

  capture(candidate: string): string {
    const current = this.getClickId();
    const next = this.model === 'first-click' && current ? current : candidate;
    this.clickId = next;
    this.storage.set(next);
    return next;
  }

  getClickId(): string | null {
    if (this.clickId) return this.clickId;
    this.clickId = this.storage.get();
    return this.clickId;
  }

  clear(): void {
    this.clickId = null;
    this.storage.clear();
  }

  primaryQueryParameter(): string {
    return this.queryParameters[0];
  }
}
